import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  size?: 'md' | 'lg';
  className?: string;
  withArrow?: boolean;
}
export function CTAButton({
  text = 'Sí, quiero el kit completo',
  subtext,
  size = 'lg',
  className = '',
  withArrow = true
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'py-4 px-6 text-lg' : 'py-3 px-5 text-base';
  return <motion.a href="https://impulsodigital.vip/cart/44763616936022:1" className={`group inline-flex items-center justify-center gap-2 w-full max-w-md mx-auto rounded-2xl bg-brand-green-500 hover:bg-brand-green-600 text-white font-bold ${sizing} shadow-btn transition-all duration-200 ${className}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} data-id="element-50">
      <span className="text-center leading-tight" data-id="element-51">
        {text}
        {subtext && <span className="block mt-0.5 text-xs font-medium opacity-90" data-id="element-52">
            {subtext}
          </span>}
      </span>
      {withArrow && <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1 shrink-0" data-id="element-53" />}
    </motion.a>;
}